module.exports = __webpack_public_path__ + "media/speed.3e9c756b.wav";